const startGleapSession = async (token, prefix) => {
  let url = prefix + `support/gleap-session`;
  let headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the POST request
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    });

    // Check if the request was successful
    if (response.ok) {
      // Handle successful response
      return response.json();
    } else {
      // Handle error response
      console.error(`Exception occurred: ${response.status}`);

      return false;
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return false;
  }
};

export default startGleapSession;
